var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TutorialInterfaceItem',{attrs:{"isShowing":_vm.isShowing}},[_c('FoodBag',{attrs:{"slot":"component"},slot:"component"})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c21818e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tutorial/TutorialFoodBag.vue
// module id = null
// module chunks = 